import { render, staticRenderFns } from "./GiftBoxFaq.vue?vue&type=template&id=3ae47ff3&scoped=true&"
import script from "./GiftBoxFaq.vue?vue&type=script&lang=js&"
export * from "./GiftBoxFaq.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxFaq.vue?vue&type=style&index=0&id=3ae47ff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae47ff3",
  null
  
)

export default component.exports